export interface AnimeItem {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  rating: number;
  episodes: number;
  status: string;
  releaseYear: number;
  tags: string[];
  content: string;
  updateDate: string;
}

export interface AnimeCategory {
  name: string;
  slug: string;
  description: string;
}

export const animeCategories: AnimeCategory[] = [
  { name: '最新番剧', slug: 'latest', description: '每周更新最热番剧，第一时间追番不等待' },
  { name: '热门推荐', slug: 'popular', description: '全网热度最高的精选动漫合集，万人追番首选' },
  { name: '经典回顾', slug: 'classic', description: '历久弥新的动漫神作，重温那些年感动我们的经典' },
  { name: '独家资源', slug: 'exclusive', description: '羞羞动漫独家引进的高品质番剧，别处找不到' },
];

export const animeList: AnimeItem[] = [
  {
    id: '1',
    title: '暗夜猎手',
    slug: 'anye-lieshou',
    category: '最新番剧',
    categorySlug: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20style%20illustration%20of%20a%20mysterious%20hunter%20in%20black%20cloak%20holding%20a%20glowing%20weapon%2C%20dramatic%20moonlight%20backlighting%2C%20gothic%20atmosphere%2C%20detailed%20character%20design%2C%20deep%20crimson%20and%20black%20color%20palette%2C%20anime%20key%20visual%20quality%2C%20cinematic%20composition%2C%20dark%20fantasy%20aesthetic&width=800&height=1120&seq=anime-cover-01&orientation=portrait',
    description: '在暗夜中狩猎异界来客的神秘猎手，背负着不为人知的过去。当世界的平衡被打破，他将如何抉择？',
    rating: 9.2,
    episodes: 24,
    status: '连载中',
    releaseYear: 2026,
    tags: ['暗黑奇幻', '动作', '悬疑'],
    content: '<p>《暗夜猎手》是一部融合了暗黑奇幻与悬疑元素的原创动画作品。故事背景设定在一个被异界力量侵蚀的近未来世界，主角「凌夜」是一名专门猎杀从异界裂缝中逃逸的怪物的猎手。</p><p>在这个世界上，人类与异界生物之间的界限日益模糊。凌夜拥有特殊的能力——他能够感知异界能量的波动，并使用特制的武器对抗那些常人无法看见的威胁。然而，随着剧情推进，凌夜发现这些异界入侵背后隐藏着更大的阴谋。</p><p>动画制作精良，战斗场面流畅震撼，角色塑造深刻立体。每一集都充满了紧张刺激的战斗与令人意想不到的剧情转折。配乐由知名作曲家操刀，完美烘托了作品暗黑而优雅的氛围。</p>',
    updateDate: '2026-08-10',
  },
  {
    id: '2',
    title: '星辰之海',
    slug: 'xingchen-zhihai',
    category: '最新番剧',
    categorySlug: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20sci-fi%20anime%20illustration%20of%20a%20girl%20floating%20in%20cosmic%20ocean%20of%20stars%2C%20ethereal%20glowing%20nebula%20background%2C%20flowing%20hair%20in%20zero%20gravity%2C%20dreamy%20pastel%20colors%20with%20deep%20space%20contrast%2C%20emotional%20anime%20key%20visual%2C%20celestial%20aesthetic%2C%20soft%20lighting&width=800&height=1120&seq=anime-cover-02&orientation=portrait',
    description: '在浩瀚星海中寻找失落文明的少女，一段跨越星际的奇幻冒险即将展开。',
    rating: 9.5,
    episodes: 12,
    status: '连载中',
    releaseYear: 2026,
    tags: ['科幻', '冒险', '治愈'],
    content: '<p>《星辰之海》讲述了少女「星野琉璃」在宇宙中寻找失落文明的动人故事。在遥远的未来，人类已经遍布银河系的各个角落，但一个古老的传说始终吸引着探险家们——据说在银河系的边缘，存在着一个早已消亡的高度文明，留下了无尽的宝藏与知识。</p><p>琉璃继承了她父亲未竟的事业，驾驶着改造后的宇宙飞船「海风号」踏上了这段充满未知的旅程。在旅途中，她遇到了形形色色的伙伴，经历了危险与感动，逐渐揭开了失落文明的神秘面纱。</p><p>本作以其精美的宇宙场景描绘和温暖人心的故事著称。每一颗星球都有独特的设计，每一个文明遗迹都承载着令人深思的历史。配乐空灵悠远，与浩瀚星空的画面完美融合。</p>',
    updateDate: '2026-08-09',
  },
  {
    id: '3',
    title: '烈焰守护者',
    slug: 'lieyan-shouhuzhe',
    category: '热门推荐',
    categorySlug: 'popular',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20illustration%20of%20a%20warrior%20wreathed%20in%20flames%2C%20wielding%20a%20massive%20sword%2C%20standing%20before%20a%20burning%20ancient%20temple%2C%20intense%20orange%20and%20red%20fire%20effects%2C%20heroic%20pose%2C%20detailed%20armor%20design%2C%20anime%20action%20key%20visual%2C%20dramatic%20lighting&width=800&height=1120&seq=anime-cover-03&orientation=portrait',
    description: '掌控远古火焰之力的守护者，为了保护最后的圣地而与黑暗势力展开殊死搏斗。',
    rating: 9.7,
    episodes: 36,
    status: '已完结',
    releaseYear: 2025,
    tags: ['热血', '奇幻', '战斗'],
    content: '<p>《烈焰守护者》是一部让人热血沸腾的奇幻战斗动画。故事围绕着继承了远古火焰之力的守护者「炎真」展开，他肩负着保护人类最后圣地的使命。</p><p>在千年前的大战中，守护者们用生命封印了黑暗之主。如今封印即将瓦解，炎真必须在有限的时间内找到其他守护者的继承人，重新点燃守护之火。然而，黑暗势力的爪牙已经渗透到世界的每个角落，一场关乎人类存亡的大战一触即发。</p><p>本作以其酣畅淋漓的战斗场景和精心设计的魔法体系赢得了广泛好评。火焰特效的呈现堪称业界顶尖水平，每一场战斗都充满了视觉震撼力。角色的成长弧线完整而感人，友情与信念的主题贯穿始终。</p>',
    updateDate: '2025-12-20',
  },
  {
    id: '4',
    title: '幻境迷踪',
    slug: 'huanjing-mizong',
    category: '热门推荐',
    categorySlug: 'popular',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20psychological%20anime%20illustration%20of%20a%20character%20walking%20through%20a%20surreal%20mirror%20maze%2C%20fragmented%20reflections%2C%20dreamlike%20atmosphere%2C%20purple%20and%20teal%20color%20scheme%2C%20mind-bending%20perspective%2C%20artistic%20anime%20key%20visual%2C%20ethereal%20glowing%20elements&width=800&height=1120&seq=anime-cover-04&orientation=portrait',
    description: '被困于无限幻境中的少年，必须解开层层谜题才能回到现实世界。谜底背后，真相令人窒息。',
    rating: 9.4,
    episodes: 16,
    status: '已完结',
    releaseYear: 2025,
    tags: ['悬疑', '心理', '奇幻'],
    content: '<p>《幻境迷踪》是一部将悬疑与心理惊悚完美融合的动画杰作。主角「雾岛诚」某天醒来发现自己被困在一个与现实世界完全相同的幻境之中，而每一次试图逃脱都会将他带入更深层的幻境。</p><p>在这个层层嵌套的幻境迷宫中，雾岛诚遇到了其他同样被困的人。他们必须合作解开幻境的秘密，但随着深入，每个人内心深处的恐惧和秘密都被一一揭示。真相远比他们想象的更加残酷——这个幻境本身就是由他们的集体潜意识构建的。</p><p>本作以其精巧的叙事结构和令人惊叹的视觉设计赢得了极高的评价。每一层幻境都有独特的视觉风格，从古典到赛博朋克，从田园牧歌到末日废土。剧情的反转出人意料却又合乎逻辑。</p>',
    updateDate: '2025-11-15',
  },
  {
    id: '5',
    title: '极寒纪元',
    slug: 'jihan-jiyuan',
    category: '经典回顾',
    categorySlug: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20anime%20illustration%20of%20a%20lonely%20survivor%20in%20a%20frozen%20wasteland%2C%20ancient%20ruins%20covered%20in%20ice%2C%20northern%20lights%20in%20the%20sky%2C%20cold%20blue%20and%20white%20color%20palette%2C%20melancholic%20atmosphere%2C%20detailed%20winter%20gear%20design%2C%20anime%20cinematic%20visual&width=800&height=1120&seq=anime-cover-05&orientation=portrait',
    description: '冰封世纪末的生存之旅，人类文明最后的火种在极寒中顽强燃烧。',
    rating: 9.6,
    episodes: 48,
    status: '已完结',
    releaseYear: 2024,
    tags: ['末世', '冒险', '科幻'],
    content: '<p>《极寒纪元》是一部描绘冰封末世中人类求生故事的史诗级动画。在不久的将来，一场名为「永冬」的气候灾难将地球变成了冰封的地狱。幸存的人类聚集在赤道附近最后的温暖地带，建立了名为「炉心城」的最后都市。</p><p>主角「冰室拓真」是一名被派遣前往极北之地寻找传说中的「地热能源核心」的探索者。在漫长的旅途中，他不仅要与严酷的自然环境抗争，还要面对其他幸存者群体之间的纷争与背叛。但正是在这种极端环境下，人性的光辉也被无限放大。</p><p>本作以其宏大的世界观和深刻的主题思考被誉为近年来最优秀的科幻动画之一。冰雪景观的描绘令人叹为观止，从冰晶森林到极光苍穹，每一帧画面都如同艺术品般精美。</p>',
    updateDate: '2024-06-30',
  },
  {
    id: '6',
    title: '龙之觉醒',
    slug: 'long-zhijuexing',
    category: '经典回顾',
    categorySlug: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=Majestic%20fantasy%20anime%20illustration%20of%20a%20young%20dragon%20rider%20with%20a%20massive%20ancient%20dragon%20soaring%20through%20stormy%20skies%2C%20lightning%20crackling%2C%20epic%20scale%2C%20detailed%20dragon%20scales%20and%20rider%20armor%2C%20anime%20fantasy%20key%20visual%2C%20golden%20and%20emerald%20accents&width=800&height=1120&seq=anime-cover-06&orientation=portrait',
    description: '被选中的少年与远古巨龙签订契约，在龙族与人族的战争中谱写传奇。',
    rating: 9.3,
    episodes: 52,
    status: '已完结',
    releaseYear: 2023,
    tags: ['奇幻', '冒险', '成长'],
    content: '<p>《龙之觉醒》是一部充满史诗感的奇幻冒险动画。故事发生在一个龙族与人类共存的世界，千年前双方签订了和平契约，龙族退隐于天际，人类则在地上建立了繁荣的文明。然而，和平即将被打破。</p><p>少年「龙崎翔」在一次意外中发现了一枚神秘的龙蛋，当他与孵化出的幼龙建立了心灵链接后，被卷入了龙族内部关于是否重返人间的激烈争斗。翔必须在龙族的古老传统和人类的现代文明之间找到平衡点，阻止一场可能毁灭双方的战争。</p><p>本作龙的设定极具创意，每条龙都有着独特的外观、能力和个性。空战场景的视觉表现力令人印象深刻，3D与2D动画的融合达到了新的高度。</p>',
    updateDate: '2023-12-01',
  },
  {
    id: '7',
    title: '时光旅人',
    slug: 'shiguang-lvren',
    category: '独家资源',
    categorySlug: 'exclusive',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20time-travel%20anime%20illustration%20of%20two%20characters%20reaching%20for%20each%20other%20across%20a%20clockwork%20void%2C%20gears%20and%20pocket%20watches%20floating%2C%20warm%20golden%20light%2C%20nostalgic%20atmosphere%2C%20detailed%20steampunk%20elements%2C%20emotional%20anime%20key%20visual%2C%20cherry%20blossom%20petals&width=800&height=1120&seq=anime-cover-07&orientation=portrait',
    description: '能够穿梭时空的神秘少女，在时间的缝隙中寻找属于自己真正的归宿。',
    rating: 9.1,
    episodes: 20,
    status: '已完结',
    releaseYear: 2025,
    tags: ['恋爱', '奇幻', '时光'],
    content: '<p>《时光旅人》是一部温柔而深刻的时间旅行题材动画。主角「时雨千夏」拥有一个秘密——她可以在梦中穿越到过去和未来的任意时间点。但这个能力也有代价，每次穿越都会消耗她的生命力。</p><p>千夏在一次穿越中遇到了同样具有时间感知能力的少年「刻也」，两人在不同的时间线上一次次相遇、分离、再相遇。随着故事展开，千夏发现她们之间的羁绊远比想象中更加深远——他们其实是同一灵魂在不同时空中的碎片。</p><p>本作以其细腻的情感刻画和唯美的视觉风格打动了许多观众。不同时代的场景还原度极高，从大正浪漫到赛博未来，每个时代都充满了令人心动的细节。音乐同样出色，主题曲获得了当年的最佳动画歌曲奖。</p>',
    updateDate: '2025-09-20',
  },
  {
    id: '8',
    title: '月下魅影',
    slug: 'yuexia-meiying',
    category: '独家资源',
    categorySlug: 'exclusive',
    coverImage: 'https://readdy.ai/api/search-image?query=Gothic%20romance%20anime%20illustration%20of%20a%20beautiful%20vampire%20lady%20under%20full%20moon%2C%20flowing%20black%20dress%2C%20ancient%20castle%20silhouette%2C%20crimson%20roses%2C%20mysterious%20elegant%20atmosphere%2C%20detailed%20lace%20and%20jewelry%2C%20anime%20dark%20fantasy%20visual%2C%20silver%20moonlight&width=800&height=1120&seq=anime-cover-08&orientation=portrait',
    description: '月圆之夜，古老贵族宅邸中的魅影传说，一段被诅咒的永恒之恋。',
    rating: 9.0,
    episodes: 14,
    status: '已完结',
    releaseYear: 2025,
    tags: ['奇幻', '恋爱', '哥特'],
    content: '<p>《月下魅影》是一部将哥特式浪漫与日式美学完美融合的动画。故事发生在一座被迷雾笼罩的古老宅邸中，传说每到月圆之夜，宅邸中就会出现一位绝美的魅影。</p><p>大学生「月岛优」暑假期间来到了这座宅邸所在的偏远小镇进行民俗学研究。在一个满月的夜晚，他遇到了那位传说中的魅影——「露娜」，一位被困在宅邸中数百年的贵族少女。随着调查深入，优发现露娜身上隐藏着一个关于爱、背叛和永生诅咒的悲剧故事。</p><p>本作的视觉风格极具辨识度，融合了维多利亚时代的华美与日式物哀的幽寂。月光下的场景尤为惊艳，银色的光芒与深红色的玫瑰形成了强烈的视觉对比。</p>',
    updateDate: '2025-08-15',
  },
  {
    id: '9',
    title: '深渊回响',
    slug: 'shenyuan-huixiang',
    category: '最新番剧',
    categorySlug: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20horror%20anime%20illustration%20of%20a%20character%20descending%20into%20an%20endless%20abyss%2C%20twisted%20shadows%2C%20glowing%20eyes%20in%20darkness%2C%20vertigo-inducing%20perspective%2C%20deep%20purple%20and%20black%20tones%2C%20unsettling%20atmosphere%2C%20anime%20horror%20key%20visual&width=800&height=1120&seq=anime-cover-09&orientation=portrait',
    description: '探索未知深渊的调查队，每一步都在逼近疯狂的边缘。深渊之下，恐惧有了形状。',
    rating: 8.9,
    episodes: 18,
    status: '连载中',
    releaseYear: 2026,
    tags: ['恐怖', '心理', '冒险'],
    content: '<p>《深渊回响》是一部令人不寒而栗的心理恐怖动画。故事讲述了一支由地质学家、心理学家和探险家组成的调查队，深入地球上一个突然出现的巨大深渊进行考察的经历。</p><p>这个深渊仿佛具有生命，它会扭曲进入者的大脑，让他们看到自己最深的恐惧。随着调查队不断深入，队员们开始出现幻觉，彼此的信任逐渐瓦解。深渊似乎也在向他们传达着某种古老而不可名状的信息——它不是一个洞，而是某种存在的入口。</p><p>本作的恐怖不在于突如其来的惊吓，而在于缓慢渗透的心理压迫。画面对深渊的描绘极具想象力，每深入一层，环境的异样感就增强一分。音效设计尤其出色，深渊的回响会在观众耳机中久久萦绕。</p>',
    updateDate: '2026-08-11',
  },
  {
    id: '10',
    title: '苍穹之翼',
    slug: 'cangqiong-zhiyi',
    category: '热门推荐',
    categorySlug: 'popular',
    coverImage: 'https://readdy.ai/api/search-image?query=Inspiring%20aviation%20anime%20illustration%20of%20a%20pilot%20standing%20on%20a%20floating%20island%20with%20mechanical%20wings%2C%20endless%20blue%20sky%2C%20clouds%20below%2C%20steampunk%20airships%20in%20distance%2C%20freedom%20theme%2C%20bright%20optimistic%20colors%2C%20anime%20adventure%20visual&width=800&height=1120&seq=anime-cover-10&orientation=portrait',
    description: '在云端之上的浮空岛屿，少年驾驶着机械翼追逐成为天空骑士的梦想。',
    rating: 9.3,
    episodes: 26,
    status: '已完结',
    releaseYear: 2025,
    tags: ['冒险', '蒸汽朋克', '励志'],
    content: '<p>《苍穹之翼》构建了一个令人心驰神往的天空世界。在这个世界里，人类生活在漂浮于云海之上的众多岛屿上，而「天空骑士」是最受尊敬的职业——他们驾驶着机械翼在岛屿之间穿梭，保护着人们的安全。</p><p>主角「风见隼人」出生在一个普通的修理铺家庭，从小就梦想成为一名天空骑士。尽管先天体质不适合驾驶机械翼，但他凭借着对天空的热爱和不懈的努力，一步步向梦想靠近。在学院中，他结识了来自不同背景的朋友们，共同成长，一同面对即将到来的天空危机。</p><p>本作飞行场景的视觉呈现令人叹为观止。云海、夕阳、星辰——天空的每一个表情都被赋予了诗意的描绘。机械翼的设计既有蒸汽朋克的厚重感，又不失优雅流畅。</p>',
    updateDate: '2025-10-10',
  },
  {
    id: '11',
    title: '血色黎明',
    slug: 'xuese-liming',
    category: '经典回顾',
    categorySlug: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=Gritty%20noir%20anime%20illustration%20of%20a%20detective%20in%20trench%20coat%20standing%20under%20a%20red-tinted%20dawn%20sky%2C%20rain-slicked%20city%20streets%2C%20cigarette%20smoke%2C%20vintage%20atmosphere%2C%20deep%20shadows%2C%20film%20noir%20lighting%2C%20anime%20crime%20thriller%20visual&width=800&height=1120&seq=anime-cover-11&orientation=portrait',
    description: '在腐败都市的黎明前，一名硬汉侦探将揭开层层血色阴谋。真相永远在黎明之前。',
    rating: 9.5,
    episodes: 22,
    status: '已完结',
    releaseYear: 2024,
    tags: ['悬疑', '犯罪', '黑色电影'],
    content: '<p>《血色黎明》是一部风格独特的黑色电影风格动画。故事设定在一个虚构的现代都市「夜都」，这里腐败横行，犯罪猖獗。主角「黑泽诚」是这座城市中少有的还坚持正义的私家侦探。</p><p>一个雨夜，一位神秘女子来到黑泽的办公室，委托他调查一起看似普通的失踪案。但随着调查深入，黑泽发现自己卷入了一个涉及政界高层、黑帮势力和跨国企业的巨大阴谋。每一个线索都指向一个可怕的事实——这个城市本身的建立就建立在血与谎言之上的。</p><p>本作致敬了经典的黑色电影风格，采用了大量低角度镜头和强烈的明暗对比。角色的对话充满了硬汉文学的气息，每一句台词都经过精心打磨。爵士风格的配乐更是为本作增添了独特的韵味。</p>',
    updateDate: '2024-09-01',
  },
  {
    id: '12',
    title: '梦境边境',
    slug: 'mengjing-bianjing',
    category: '独家资源',
    categorySlug: 'exclusive',
    coverImage: 'https://readdy.ai/api/search-image?query=Surreal%20dreamscape%20anime%20illustration%20of%20a%20girl%20walking%20on%20a%20path%20made%20of%20floating%20memories%2C%20fragmented%20childhood%20scenes%2C%20soft%20watercolor%20texture%2C%20ethereal%20pastel%20colors%2C%20bittersweet%20nostalgia%2C%20artistic%20anime%20visual%2C%20dreamlike%20floating%20elements&width=800&height=1120&seq=anime-cover-12&orientation=portrait',
    description: '梦境与现实交汇的边境地带，一位少女在此收集着人们遗忘的记忆碎片。',
    rating: 8.8,
    episodes: 10,
    status: '已完结',
    releaseYear: 2025,
    tags: ['奇幻', '治愈', '文艺'],
    content: '<p>《梦境边境》是一部充满诗意和想象力的治愈系动画。故事设定在梦境与现实的交界处——一个被称为「边境」的奇妙空间。在这里，所有被人类遗忘的记忆都会化作发光的碎片，漂浮在无尽的意识之海中。</p><p>少女「梦野堇」是边境的守护者，她的工作是收集这些记忆碎片，将它们编织成完整的梦境，送还给它们的主人。每一集都是一个独立的故事，讲述不同人们遗忘的记忆——有童年的欢笑、初恋的心动、亲人的温暖，也有被刻意压抑的伤痛。</p><p>本作的视觉风格采用了水彩画般的质感，柔和而梦幻。每一个梦境世界都有着独特的设计，从儿童绘本风格到东方水墨意境，展现出了动画艺术的无限可能。</p>',
    updateDate: '2025-07-20',
  },
  {
    id: '13',
    title: '钢铁誓约',
    slug: 'gangtie-shiyue',
    category: '最新番剧',
    categorySlug: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Mecha%20anime%20illustration%20of%20a%20giant%20robot%20kneeling%20with%20its%20pilot%20standing%20on%20its%20shoulder%2C%20battle-damaged%20armor%2C%20sunset%20battlefield%2C%20smoke%20and%20debris%2C%20emotional%20farewell%20scene%2C%20detailed%20mechanical%20design%2C%20anime%20sci-fi%20key%20visual&width=800&height=1120&seq=anime-cover-13&orientation=portrait',
    description: '机甲与信念的终极碰撞！少年驾驶员们在钢铁巨兽中书写属于他们的誓约。',
    rating: 9.4,
    episodes: 30,
    status: '连载中',
    releaseYear: 2026,
    tags: ['机甲', '科幻', '战争'],
    content: '<p>《钢铁誓约》是一部回归机甲动画本源的硬核科幻作品。故事发生在近未来，人类开发出了名为「誓约机甲」的巨大战斗机器人，用以对抗来自外太空的不明生物「异形者」。</p><p>「钢铁学院」是培养机甲驾驶员的最高学府。主角「铁也」以最后一名的成绩考入学院，但他体内隐藏着与誓约机甲产生共鸣的特殊能力。随着异形者的威胁日益加剧，铁也和同学们提前被投入到了残酷的战场之中。</p><p>本作的机甲设计极具匠心，每一台誓约机甲都有详细的设定和独特的战斗风格。战斗场景以实感为主，强调了机甲的重量感和机械感。剧情对战争的残酷性和青少年的成长进行了深刻的探讨。</p>',
    updateDate: '2026-08-08',
  },
  {
    id: '14',
    title: '永恒之塔',
    slug: 'yongheng-zhita',
    category: '热门推荐',
    categorySlug: 'popular',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20adventurers%20climbing%20a%20tower%20that%20pierces%20through%20clouds%20into%20heaven%2C%20each%20floor%20a%20different%20world%2C%20epic%20vertical%20composition%2C%20diverse%20environments%2C%20anime%20isekai%20key%20visual%2C%20golden%20light%20from%20above&width=800&height=1120&seq=anime-cover-14&orientation=portrait',
    description: '通天之塔的每一层都是一个世界。攀登者们在无尽的阶梯上追寻着各自的愿望。',
    rating: 9.6,
    episodes: 40,
    status: '连载中',
    releaseYear: 2026,
    tags: ['异世界', '冒险', '群像'],
    content: '<p>《永恒之塔》构建了一个令人叹为观止的垂直世界。在世界的中心矗立着一座直通天际的巨塔，没有人知道它有多少层，也没有人知道塔顶存在着什么。但传说中，到达塔顶的人可以实现任何一个愿望。</p><p>故事同时追踪了多位攀登者——为了救治妹妹绝症的少年「塔矢望」、寻找失踪恋人的女剑士「艾莉西亚」、渴望证明自己的矮人锻造师「多瓦夫」，以及隐藏着神秘身份的盲眼法师「暗」。他们的命运在塔中交织，彼此之间的羁绊成为了攀登的最大动力。</p><p>本作的亮点在于每一层塔都是一个独立的小世界，拥有着完全不同的文明、生态和法则。从蒸汽朋克城市到魔法森林，从水下王国到虚空之境，想象力令人叹服。</p>',
    updateDate: '2026-08-07',
  },
  {
    id: '15',
    title: '虚空行者',
    slug: 'xukong-xingzhe',
    category: '经典回顾',
    categorySlug: 'classic',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20wuxia%20anime%20illustration%20of%20a%20wandering%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20cliff%20edge%2C%20misty%20mountains%2C%20calligraphy%20energy%20swirls%2C%20traditional%20eastern%20aesthetic%2C%20ink%20wash%20painting%20style%2C%20anime%20martial%20arts%20visual&width=800&height=1120&seq=anime-cover-15&orientation=portrait',
    description: '一位行走于虚空中的流浪剑客，以手中长剑斩断命运的枷锁。东方武侠的极致演绎。',
    rating: 9.7,
    episodes: 32,
    status: '已完结',
    releaseYear: 2023,
    tags: ['武侠', '东方奇幻', '群像'],
    content: '<p>《虚空行者》是一部融合了中国武侠精神与日本动画美学的杰作。故事背景设定在一个以「气」为能量基础的东方奇幻世界，修行者们通过修炼「气」来获得超越常人的力量。</p><p>主角「无名」是一位失去记忆的流浪剑客，他拥有着前无古人的能力——可以在「虚空」中行走，不受空间和时间的束缚。为了找回记忆，无名踏上了旅程，一路上遇到了各路英雄豪杰，也卷入了门派间的纷争和古老的预言之中。</p><p>本作的打斗设计堪称动作动画的巅峰之作。每一场战斗都如同精心编排的舞蹈，既有武侠的飘逸灵动，又有日式动画的爆发力。水墨风格的背景与角色的精致描绘形成了美妙的对比。</p>',
    updateDate: '2023-08-30',
  },
  {
    id: '16',
    title: '花语暗杀',
    slug: 'huayu-ansha',
    category: '独家资源',
    categorySlug: 'exclusive',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20assassin%20anime%20illustration%20of%20a%20beautiful%20female%20assassin%20surrounded%20by%20falling%20flower%20petals%2C%20hidden%20blades%2C%20contrast%20between%20beauty%20and%20danger%2C%20soft%20pink%20and%20crimson%20color%20scheme%2C%20traditional%20kimono%2C%20anime%20action%20visual&width=800&height=1120&seq=anime-cover-16&orientation=portrait',
    description: '以花为名的暗杀者，在美丽与危险之间游走。每一朵花瓣背后都藏着致命杀机。',
    rating: 9.2,
    episodes: 13,
    status: '已完结',
    releaseYear: 2025,
    tags: ['动作', '剧情', '女性主角'],
    content: '<p>《花语暗杀》是一部风格独特的美少女动作动画。主角「花咲小夜」表面上是一家花店的温柔店主，实际上却是一名技艺高超的暗杀者，专门接受委托清除社会的毒瘤。</p><p>小夜的代号是「花语」，每一次行动都会在目标身边留下一朵特定的花作为标记。十二种花代表着十二种暗杀方式，每一种都如同艺术般优雅。但随着剧情展开，小夜发现自己所在的暗杀组织背后隐藏着不可告人的秘密，她必须做出选择——继续服从还是反抗。</p><p>本作的美术风格在华美与黑暗之间取得了绝妙的平衡。花朵的描绘极尽精致，每一帧都如同插画般美丽。而暗杀场景则以高度风格化的方式呈现，避免了血腥场面，转而追求视觉上的诗意表达。</p>',
    updateDate: '2025-05-20',
  },
];

export const siteInfo = {
  name: '羞羞动漫',
  tagline: '专为成熟动漫爱好者打造的高清内容平台',
  description: '羞羞动漫是专为成熟动漫爱好者打造的内容平台，提供海量高清动漫资源、独家番剧更新与流畅播放体验。立即探索羞羞动漫全库内容，满足你对二次元世界的全部幻想。',
  email: 'contact@hfcstore.cn',
  address: '上海市浦东新区张江高科技园区动漫产业基地',
  founded: '2020',
  totalUsers: '500万+',
  totalAnime: '3000+',
  dailyUpdate: '50+',
};

export const aboutFaqs = [
  {
    question: '羞羞动漫平台上的内容是否正版授权？',
    answer: '羞羞动漫所有内容均已获得正版授权，我们与国内外多家知名动漫制作公司和发行商建立了长期合作关系。用户可以在平台上放心观看所有高清番剧资源，享受流畅、安全的观影体验。',
  },
  {
    question: '如何注册成为羞羞动漫会员？',
    answer: '您可以通过手机号或邮箱快速注册羞羞动漫账号。注册完成后即可浏览全站内容。我们还提供会员升级服务，会员用户可以享受更高清画质、去广告观影以及优先观看独家番剧等特权。',
  },
  {
    question: '羞羞动漫支持哪些设备观看？',
    answer: '羞羞动漫全面支持PC端网页、iOS和Android移动设备、平板电脑以及智能电视投屏。您可以在任何设备上无缝切换观看体验，所有观看记录和收藏都会自动同步。',
  },
  {
    question: '番剧更新频率是怎样的？',
    answer: '羞羞动漫每天更新50部以上番剧内容。连载中的热门番剧通常在播出后24小时内上线中文字幕版。我们拥有专业的翻译团队，确保字幕质量和更新速度。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您在使用过程中遇到任何播放问题，可以尝试切换播放线路或清晰度。大多数播放问题可以通过刷新页面或切换网络环境解决。如问题仍未解决，我们的客服团队7x24小时在线待命，随时为您提供帮助。',
  },
];

export const testimonials = [
  {
    name: '动漫达人Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20simple%20clean%20background%2C%20modern%20anime%20art%20style%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    comment: '用了羞羞动漫三年多，资源更新速度真的没话说。画质高清，字幕翻译也很到位，是我最信赖的动漫平台。',
    rating: 5,
  },
  {
    name: '二次元少女Mia',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20simple%20clean%20background%2C%20cute%20anime%20art%20style%2C%20gentle%20smile&width=120&height=120&seq=avatar-02&orientation=squarish',
    comment: '独家资源区真的是宝藏！很多在其他平台找不到的番剧在这里都能看到，会员超值！',
    rating: 5,
  },
  {
    name: '老二次元阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20simple%20clean%20background%2C%20cool%20anime%20art%20style%2C%20confident%20look&width=120&height=120&seq=avatar-03&orientation=squarish',
    comment: '界面简洁清爽，没有乱七八糟的广告。分类也很清晰，找番特别方便。推荐给所有动漫爱好者！',
    rating: 5,
  },
];